/**
 * Mag dit beheerscherm open, of toont de schil "Geen toegang" (FBK-2)?
 *
 * Een pagina vraagt hetzelfde als haar menu-item: staat het item in het menu van deze beheerder,
 * dan mag hij erin. Staat het er niet, maar wel als alle vlaggen aan staan, dan mist niet het recht
 * maar staat de functie uit.
 *
 * Een persoonlijke pagina heeft geen menu-item: ze hangt in het menu onder je naam en gaat over
 * jezelf (je eigen wachtwoord). Daar is geen recht voor nodig, alleen een sessie, en die controleert
 * de router al. Zonder deze uitzondering kreeg elke beheerder "Geen toegang" op Wachtwoord wijzigen
 * (testrapport 28 okt., fout 1). De lijst is bewust een vaste lijst: een onbekende sleutel blijft
 * dicht, zodat een tikfout in de router geen scherm openzet.
 */
export type PageBlock = 'noRight' | 'featureOff' | null;

/** De `activeKey`s van de schermen over jezelf, die iedere aangemelde beheerder mag openen. */
export const PERSONAL_PAGES: ReadonlySet<string> = new Set(['account']);

export function pageBlock(input: {
  activeKey: string;
  /** De sleutels in het menu van deze beheerder, met zijn rechten en de vlaggen van het bedrijf. */
  shown: ReadonlySet<string>;
  /** De sleutels in zijn menu als alle vlaggen aan stonden. */
  withAllFeatures: ReadonlySet<string>;
}): PageBlock {
  if (PERSONAL_PAGES.has(input.activeKey)) return null;
  if (input.shown.has(input.activeKey)) return null;
  return input.withAllFeatures.has(input.activeKey) ? 'featureOff' : 'noRight';
}
